import { HTTPAPIConfig } from './http-api.config';
/**
 * will have all the api config mapping for the project
 */
export const APIConfigMapping: {
  [key: string]: HTTPAPIConfig
} = {
  GET_STATIONS: {
    method: 'get',
    apiKeyName: 'GET_STATIONS',
  },

  GET_STATION_BY_ID: {
    method: 'get',
    apiKeyName: 'GET_STATION_BY_ID',
  },

  ADD_STATION: {
    method: 'post',
    apiKeyName: 'ADD_STATION',
  },

  UPLOAD_SIP_AND_GRADIENT: {
    method: 'multipart',
    apiKeyName: 'UPLOAD_SIP_AND_GRADIENT',
  },
  GET_PROCESSING_STATUS: {
    method: 'post',
    apiKeyName: 'GET_PROCESSING_STATUS',
  },

  GET_TRACKS: {
    method: 'get',
    apiKeyName: 'GET_TRACKS',
  },

  ADD_TRACK: {
    method: 'post',
    apiKeyName: 'ADD_TRACK',
  },

  ADD_STATION_SURVERY: {
    method: 'post',
    apiKeyName: 'ADD_STATION_SURVERY',
  }, 
  FETCH_SURVEY_META_FILES: {
    method: 'post',
    apiKeyName: 'FETCH_SURVEY_META_FILES',
  }, 
  GET_PIM_SIP_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_SIP_FILE',
  },
  GET_PIM_GRADIENT_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_GRADIENT_FILE',
  },
  POST_EDIT_TABLE_DATA: {
    method: 'multipart',
    apiKeyName: 'POST_EDIT_TABLE_DATA'
  },
  GET_PIM_SIGNALLING_FILE: {
    method: 'post',
    apiKeyName: 'GET_PIM_SIGNALLING_FILE'
  },
  GET_CHILD_ROLE_USERS: {
    method: 'get',
    apiKeyName: 'GET_CHILD_ROLE_USERS',
    urlString:'USERMGMT_API'
  },
  GET_PARENT_ROLE_USERS: {
    method: 'get',
    apiKeyName: 'GET_PARENT_ROLE_USERS',
    urlString:'USERMGMT_API'
  },
  UPDATE_STATION_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_STATION_STATUS'
  },
  GET_STATION_VERSIONS: {
    method: 'post',
    apiKeyName: 'GET_STATION_VERSIONS',
  },
  GET_STATION_VERSION_FILE: {
    method: 'post',
    apiKeyName: 'GET_STATION_VERSION_FILE',
  },
  GET_ALL_SELECTED_STATIONS_FILES: {
    method: 'post',
    apiKeyName: 'GET_ALL_SELECTED_STATIONS_FILES',
  },
    ADD_SIGN_TOC: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TOC',
  },
    ADD_SIGN_TRACK_PROFILE_DATA: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TRACK_PROFILE_DATA',
  },
    ADD_SIGN_TINS_PDF: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_TINS_PDF',
  },
    ADD_SIGN_RADIO_PDF: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_RADIO_PDF',
  },
    ADD_SIGN_RFID_TAG_DATA: {
    method: 'multipart',
    apiKeyName: 'ADD_SIGN_RFID_TAG_DATA',
  },

  PLOT_OR_UPDATE_SIP: {
    method: 'post',
    apiKeyName: 'PLOT_OR_UPDATE_SIP'
  },
  GENERATE_COMMENTS: {
    method: 'post',
    apiKeyName: 'GENERATE_COMMENTS'
  },


  // comments
 GET_COMMENTS: {
    method: 'post',
    apiKeyName: 'GET_COMMENTS',
  },
  ADD_COMMENT: {
    method: 'post',
    apiKeyName: 'ADD_COMMENT', 
  },
  UPDATE_COMMENT: {
    method: 'post',
    apiKeyName: 'UPDATE_COMMENT',
  },
  DELETE_COMMENT: {
    method: 'post',
    apiKeyName: 'DELETE_COMMENT',
  },
  ADD_REPLY: {
    method: 'post',
    apiKeyName: 'ADD_REPLY',
  },
  ADD_STATION_DATA: {
    method: 'post',
    apiKeyName: 'ADD_STATION_DATA',
  },
  GET_OEM_RULES: {
    method:'get',
    apiKeyName:'GET_OEM_RULES',
    urlString:'PROJ_API_URL'
  },
  GET_ALL_ZONES: {
    method: 'get',
    apiKeyName: 'GET_ALL_ZONES',
    urlString:'PROJ_API_URL'
  },
  GET_ZONE_RULES_TABLE: {
    method: 'post',
    apiKeyName: 'GET_ZONE_RULES_TABLE',
    urlString:'PROJ_API_URL'
  },
  GET_RULE_TYPES: {
    method: 'get',
    apiKeyName: 'GET_RULE_TYPES',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE_TYPES: {
    method: 'post',
    apiKeyName: 'GET_RULE_TYPES',
    urlString: 'PROJ_API_URL'
  },
  GET_RULE_CATEGORIES: {
    method: 'get',
    apiKeyName: 'GET_RULE_CATEGORIES',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE_CATEGORY: {
    method:'post',
    apiKeyName:'GET_RULE_CATEGORIES',
    urlString:'PROJ_API_URL'
  },
  UPDATE_RULE: {
    method: 'put',
    apiKeyName:'UPDATE_RULE',
    urlString:'PROJ_API_URL'
  },
  ADD_RULE:{
    method:'post',
    apiKeyName:'UPDATE_RULE',
    urlString:'PROJ_API_URL'
  },
  DELETE_RULE: {
    method: 'delete',
    apiKeyName: 'DELETE_RULE',
    urlString: 'PROJ_API_URL'
  },
  GET_SUB_TRACKS: {
    method: 'get',
    apiKeyName: 'GET_SUB_TRACKS',
  },
  ADD_SUB_TRACK: {
    method: 'post',
    apiKeyName: 'ADD_SUB_TRACK',
  },
  SAVE_SUB_TRACK_DATA: {
    method: 'post',
    apiKeyName: 'SAVE_SUB_TRACK_DATA',
  },
  SAVE_SURVEY_DRAFT: {
    method: 'post',
    apiKeyName: 'SAVE_SURVEY_DRAFT',
  },
  PROCESS_SURVEY_FILE_FIRST_PASS: {
    method: 'multipart',
    apiKeyName: 'PROCESS_SURVEY_FILE_FIRST_PASS',
    // urlString: 'MAHESH_API_ULR'
  },
  PROCESS_SURVEY_FILE_SECOND_PASS: {
    method: 'multipart',
    apiKeyName: 'PROCESS_SURVEY_FILE_SECOND_PASS',
  },
    // urlString: 'MAHESH_API_ULR'
  GET_LAYOUT_EDIT_STATUS: {
    method: 'get',
    apiKeyName: 'GET_LAYOUT_EDIT_STATUS',
  },
  UPDATE_LAYOUT_EDIT_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_LAYOUT_EDIT_STATUS',
  },
  UPDATE_DRAFT_ACCESS_STATUS: {
    method: 'post',
    apiKeyName: 'UPDATE_DRAFT_ACCESS_STATUS',
  },
  GENERATE_TOC_DOC: {
    method: 'post',
    apiKeyName: 'GENERATE_TOC_DOC',
    options: {
      responseType: 'blob'
    }
  },
  GENERATE_TPT_DOC: {
    method: 'post',
    apiKeyName: 'GENERATE_TPT_DOC',
    options: {
      responseType: 'blob'
    }
  },
  GET_ZONE_LIST: {
    method: 'post',
    apiKeyName: 'GET_ZONE_LIST'
  },
  GET_VENDOR_LIST: {
    method: 'post',
    apiKeyName: 'GET_VENDOR_LIST'
  },
  GET_HEADER_TYPES: {
    method: 'post',
    apiKeyName: 'GET_HEADER_TYPES'
  },
  CREATE_OR_UPDATE_TOC_HEADER: {
    method: 'post',
    apiKeyName: 'CREATE_OR_UPDATE_TOC_HEADER'
  },
  GET_TOC_HEADER_DATA: {
    method: 'post',
    apiKeyName: 'GET_TOC_HEADER_DATA'
  },
  UPDATE_SIGNALLING_TOC_DATA: {
    method: 'post',
    apiKeyName: 'UPDATE_SIGNALLING_TOC_DATA'
  },
  LOCK_STATION_LAYOUT: {
    method: 'post',
    apiKeyName: 'LOCK_STATION_LAYOUT',
  },
  UNLOCK_STATION_LAYOUT: {
    method: 'post',
    apiKeyName: 'UNLOCK_STATION_LAYOUT',
  },
  REFRESH_STATION_LAYOUT_LOCK: {
    method: 'post',
    apiKeyName: 'REFRESH_STATION_LAYOUT_LOCK',
  },
  GET_DB_FILE_DOWNLOAD: {
    method: 'get',
    apiKeyName: 'GET_DB_FILE_DOWNLOAD'
  },
  GET_TOC_CHEAT_SHEET_PDF: {
    method: 'get',
    apiKeyName: 'GET_TOC_CHEAT_SHEET_PDF'
  },
  COPY_SURVEY_DRAFT: {
    method: 'post',
    apiKeyName: 'COPY_SURVEY_DRAFT',
  },
  EXTRACT_PSR_EXCEL: {
    method: 'multipart',
    apiKeyName: 'EXTRACT_PSR_EXCEL'
  },
  ON_GRADIENT_FILE_UPLOAD: {
    method: 'multipart',
    apiKeyName: 'ON_GRADIENT_FILE_UPLOAD'
  },
  GET_ALL_TAG_DATA: {
    method: 'get',
    apiKeyName: 'GET_ALL_TAG_DATA'
  },
  GET_STATION_IP_ADDRESS: {
    method: 'get',
    apiKeyName: 'GET_STATION_IP_ADDRESS'
  },
  ZONE_VENDOR_TYPE_DELETE: {
    method: 'delete',
    apiKeyName: 'ZONE_VENDOR_TYPE_DELETE',
    postData: {}
  },
  GET_ZONES: {
    method: 'get',
    apiKeyName: 'GET_ZONES',
  },
  GET_DIVISIONS: {
    method: 'post',
    apiKeyName: 'GET_DIVISIONS',
  },
  GET_STATIONS_LIST: {
    method: 'post',
    apiKeyName: 'GET_STATIONS_LIST',
  },

  DELETE_STATION_MASTER_DATA:{
    method: 'post',
    apiKeyName: 'DELETE_STATION_MASTER_DATA'
  },
  GET_TRACK_WITH_ADJUSTMENT: {
    method: 'post',
    apiKeyName: 'GET_TRACK_WITH_ADJUSTMENT',
    postData: {}
  },
  SLF_CTF_FILE_UPLOAD: {
    method: 'multipart',
    apiKeyName: 'SLF_CTF_FILE_UPLOAD'
  },
  GET_SLF_CTF_FILES_DATA: {
    method: 'get',
    apiKeyName: 'GET_SLF_CTF_FILES_DATA'
  },
  GAP_INTERVAL_ANALYZER: {
    method: 'post',
    apiKeyName: 'GAP_INTERVAL_ANALYZER'
  },
  GET_LAYOUT_VERSIONS: {
    method: 'post',
    apiKeyName: 'GET_LAYOUT_VERSIONS'
  },
  GET_LAYOUT_VERSION_DATA: {
    method: 'post',
    apiKeyName: 'GET_LAYOUT_VERSION_DATA'
  },
  GET_LAYOUT_SUBMISSION_STATUS: {
    method: 'get',
    apiKeyName: 'GET_LAYOUT_SUBMISSION_STATUS'
  },

  APPLY_ANTI_COLLISION_ON_RED_AND_GREEN_DATA: {
    method: 'multipart',
    apiKeyName: 'APPLY_ANTI_COLLISION_ON_RED_AND_GREEN_DATA'
  }
}


